import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { getPriceString } from "@app/utils/localeUtils"
import { classNamez } from "@tecreation/funnel-components"
import "./TimeblockButton.css"

export default function ({ onClick, selected, type, price, disabled, showFrom, fillWidth, noRestCount = false, onKeyDown }) {
	const {
		data: { from, noVacancy, notAvailable },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<Button
			style="outlined"
			className={"mt-2 primary flex-1 " + (fillWidth ? "w-100" : fillWidth)}
			cssStyle={{ backgroundColor: selected ? "var(--color-primary-700)" : "white", height: "56px" }}
			onClick={onClick}
			disabled={disabled || noRestCount}
			fillWidth={fillWidth}
			handleKeyDown={onKeyDown}
		>
			<div>
				<div
					className={
						"regular" +
						classNamez({
							"color-fg-primary": !selected,
							"color-fg-white": selected,
						})
					}
				>
					{type}
				</div>
				<div
					className={
						"mt-1" +
						classNamez({
							"color-fg-secondary": !selected,
							"color-fg-white": selected,
						})
					}
				>
					{noRestCount ? (
						notAvailable
					) : disabled ? (
						noVacancy
					) : (
						<>
							{showFrom ? from + " " : ""}
							{getPriceString(price)}
						</>
					)}
				</div>
			</div>
		</Button>
	)
}
